// extracted by mini-css-extract-plugin
export default {"fadeIn":"style-module--fadeIn--FMhGS","fadeOut":"style-module--fadeOut--pKEjQ"};